import { render, staticRenderFns } from "./updateSceneStandardMake.vue?vue&type=template&id=96fe8240&scoped=true&"
import script from "./updateSceneStandardMake.vue?vue&type=script&lang=js&"
export * from "./updateSceneStandardMake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fe8240",
  null
  
)

export default component.exports